// Affiliate links for Resources (brief 030), keyed by the resource id in
// STUDY_RESOURCES (src/constants.js). Gokhan joins each program himself and sends
// the PM the partner URL; adding one is a one-line change here, for example:
//   osmosis: 'https://www.osmosis.org/?ref=PARTNER_ID',
// Rules: https only, the partner's own link exactly as given. Nothing about the
// user (id, email, device) is ever added to it.
export const AFFILIATE_LINKS = {
};

const safe = url => typeof url === 'string' && /^https:\/\/[^\s]+$/.test(url);

// The resource as shown: its affiliate link when one is configured, else the plain url.
export const resolveResource = (r, links = AFFILIATE_LINKS) => {
  const affiliateUrl = safe(links[r.id]) ? links[r.id] : null;
  return { ...r, affiliate: !!affiliateUrl, affiliateUrl, href: affiliateUrl || r.url };
};
